// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-card[data-v-115be728]{height:calc(100vh - 200px)}", ""]);
// Exports
module.exports = exports;
